export enum ImportQueueStatus {
    ReadyToImport,
    Importing,
    ImportFailed,
    ReadyToValidate,
    NoRfqFound,
    DocHeaderCreated,
    Deleted
}       
       
